
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { BodyLayoutComponent } from '@reflact/ngx-layout';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DividerModule } from 'primeng/divider';
import { PopoverModule } from 'primeng/popover';
import { LoginService } from '@shared-angular/services/login.service';
import { ProjectService } from 'src/app/shared/services/project.service';
import { INavData } from 'src/app/shared/types/nav-data.types';
import { APP_VERSION } from 'src/version';
import { PageHeaderComponent } from "../../../shared/components/ai-bot/page-header/page-header.component";
import { SocketAdminService } from '@shared-angular/services/socketadmin.service';

@Component({
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  imports: [RouterOutlet, RouterLink, BodyLayoutComponent,
    PopoverModule,
    DividerModule,
    BsDropdownModule,
    FormsModule,
    PageHeaderComponent
]
})
export class BotAdminComponent implements OnInit, AfterViewInit {
  @ViewChild('projectNav', { static: true }) public projectNav!: TemplateRef<unknown>;
  @ViewChild('separator', { static: true }) public separator!: TemplateRef<unknown>;
  public navItems: INavData[] = [];
  public readonly APP_VERSION = APP_VERSION;

  constructor(
    public router: Router,
    public socketAdminService: SocketAdminService,
    private loginservice: LoginService,
    public projectService: ProjectService,
    public cdr: ChangeDetectorRef
  ) {
  }

  public get isProjectSection(): boolean {
    const path = (this.router.url.split(/[?#]/)[0] ?? '').replace(/\/$/, '');
    return path === '/bot-admin' || path.startsWith('/bot-admin/project/');
  }

  public logout(): void {
    void this.loginservice.logout(true);
  }

  public async ngOnInit(): Promise<void> {
    await this.loginservice.setAdminPosition('home');
  }


  public ngAfterViewInit(): void {
    setTimeout(() => {
      const navItems: INavData[] = [
        {
          template: this.projectNav
        },
        {
          name: $localize`:@@archive:Archiv`,
          url: "/bot-admin/archive",
          icon: 'ri-archive-line'
        },
        {
          name: $localize`:@@trashbin:Papierkorb`,
          url: "/bot-admin/trash",
          icon: 'ri-delete-bin-line'
        },
        {
          template: this.separator
        },
        {
          name: $localize`:@@documentation:Handbuch`,
          href: "https://url.reflact.com/aidoc",
          icon: 'ri-book-open-line'
        }
      ];

      if (this.loginservice.hasSUPERAdmin()) {
        navItems.splice(4, 0, {
          name: $localize`:@@templates:Vorlagen verwalten`,
          url: "/bot-admin/templates",
          icon: 'ri-git-merge-line'
        });
      }

      this.navItems = navItems;
    }, 0);


  }
}
